import { saveFavoriteCamerasToStorage } from "@/features/annotation/lib/helpers";
import {
  updateSeekAmount,
  updateTimelineRangeMinutes,
  updateZoomLevel,
  addFavoriteCamera,
  removeFavoriteCamera,
} from "../slices/slice";
import type { AppStartListening } from "@/app/appMiddleware";
import type { RootState } from "@/app/appStore";
import { isAnyOf } from "@reduxjs/toolkit";

export const addAnnotationLocalStorageListeners = (
  startListening: AppStartListening
) => {
  startListening({
    actionCreator: updateZoomLevel,
    effect: (action) => {
      localStorage.setItem("zoomLevel", String(action.payload));
    },
  });

  startListening({
    actionCreator: updateSeekAmount,
    effect: (action) => {
      localStorage.setItem("seekAmount", String(action.payload));
    },
  });

  startListening({
    actionCreator: updateTimelineRangeMinutes,
    effect: (action) => {
      localStorage.setItem("timelineRange", JSON.stringify(action.payload));
    },
  });

  startListening({
    matcher: isAnyOf(addFavoriteCamera, removeFavoriteCamera),
    effect: (_action, { getState }) => {
      const state = getState() as RootState;
      saveFavoriteCamerasToStorage(state.annotation.favoriteCameras);
    },
  });
};
